import { render, staticRenderFns } from "./bestsign_content.vue?vue&type=template&id=68b81cbe&"
import script from "./bestsign_content.vue?vue&type=script&lang=js&"
export * from "./bestsign_content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68b81cbe')) {
      api.createRecord('68b81cbe', component.options)
    } else {
      api.reload('68b81cbe', component.options)
    }
    module.hot.accept("./bestsign_content.vue?vue&type=template&id=68b81cbe&", function () {
      api.rerender('68b81cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/treaty/bestsign_content.vue"
export default component.exports